export default "__VITE_ASSET__nmaWwMD08Rn0RjNBWDO4Xw__"